import { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { cambiarContrasena } from "../services/autenticacion.service";

export const CambiarContrasenaPage = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    const username = localStorage.getItem("username");
    const dataActualizar = { username, password };
    const result = await cambiarContrasena(dataActualizar);
    navigate("/");
  };

  return (
    <div className="flex h-screen">
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.2/css/all.min.css"
        />
      </Helmet>

      <div className="img w-1/2 flex justify-center items-center bg-white">
        <img src="/img/LOGIN SVG/ICON PERSONAS Y LOGO.svg" alt="Login Icon" />
      </div>
      <div
        className="login-content w-1/2 flex flex-col justify-center items-center text-center "
        style={{ backgroundColor: "#ffc201" }}
      >
        <form onSubmit={handleSubmit} className="w-96 p-8">
          <h2 className="title font-montserrat text-4xl text-white uppercase mb-6">
            CAMBIAR CONTRASEÑA
          </h2>
          <img
            src="/img/LOGIN SVG/ICONO 4.svg"
            alt="Logo"
            className="w-48 mx-auto mb-6"
          />
          <div className="flex items-center mb-4">
            <div className="w-10 h-10 bg-blue-600 flex items-center justify-center rounded-full">
              <i className="fas fa-lock text-white"></i>
            </div>
            <div className="ml-2 flex-grow">
              <input
                type="password"
                placeholder="Contraseña"
                id="password"
                name="password"
                className="input-login w-full"
                value={password}
                onChange={handlePasswordChange}
              />
            </div>
          </div>
          <div className="flex items-center mb-4">
            <div className="w-10 h-10 bg-blue-600 flex items-center justify-center rounded-full">
              <i className="fas fa-lock text-white"></i>
            </div>
            <div className="ml-2 flex-grow">
              <input
                type="password"
                placeholder="Repetir Contraseña"
                id="confirmPassword"
                name="confirmPassword"
                className="input-login w-full"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
              />
            </div>
          </div>

          <div id="error" className="mb-4">
            {error && <p>{error}</p>}
          </div>
          <div className={"flex flex-col"}>
            <button className={"btn-login"}>{"Cambiar"}</button>
          </div>
        </form>
      </div>
    </div>
  );
};
